import { Unidade } from "./unidade/model/Unidade";
import { Fornecedor } from "../ferramentasAdm/entities/Fornecedor";

const state = {
  unidadeData: false,
  todaUnidades: false,
  contract: localStorage.getItem("lastContract"),
};

const mutations = {
  SAVE_UNIDADE(state, data) {
    state.unidadeData = data;
  },
  SAVE_CONTRACT(state, data) {
    state.contract = data;
  },
  ALL_UNIDADES(state, data) {
    state.todaUnidades = data;
  },
};

const actions = {
  listarUnidades: async (context) => {
    try {
      const api = context.rootState.autenticacao.api;
      let resposta = await api.get(`/org/unidade`);

      let listaUnidades = [];

      resposta.data.resultado.dados.forEach((unidadeDTO) => {
        listaUnidades.push(
          new Unidade({
            id: unidadeDTO.unidadeId,
            nome: unidadeDTO.nome,
            logo: unidadeDTO.logo,
            codigoIntegracaoUnidade: unidadeDTO.codigoIntegracaoUnidade,
            endereco: unidadeDTO.endereco,
          })
        );
      });

      return {
        listaUnidades,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },

  listarContratosUnidade: async (context, { unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/vendors/${unidade}`);

    return response;
  },

  listarFornecedores: async (context, { paginacao, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    let params = {};

    if (search) {
      params.search = search;
    }

    if (paginacao) {
      params.per_page = paginacao.rowsPerPage;
      params.page = paginacao.page;
    }

    let resposta = await api.get(`providers`, { params });

    resposta = resposta.data;

    let listaFornecedores = [];
    resposta.results.data.forEach((grupoDTO) => {
      listaFornecedores.push(
        new Fornecedor({
          id: grupoDTO.id,
          nome: grupoDTO.business_name,
          fantasia: grupoDTO.fantasy_name,
          cnpj: grupoDTO.cnpj,
        })
      );
    });

    paginacao.page = resposta.results.current_page;
    paginacao.rowsPerPage = resposta.results.per_page;
    paginacao.rowsNumber = resposta.results.total;
    return {
      listaFornecedores,
      paginacao,
    };
  },

  editarFornecedor: async (context, { id, nome, fantasia, cnpj }) => {
    const api = context.rootState.autenticacao.apiLegado;
    await api.put(`providers/${id}`, {
      business_name: nome,
      fantasy_name: fantasia,
      cnpj: cnpj,
    });
  },

  excluirFornecedor: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`providers/${id}`);

    return response;
  },

  consultarFornecedor: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    let resposta = await api.get(`providers/${id}`);
    resposta = resposta.data;

    let fornecedor = new Fornecedor({
      id: resposta.model.id,
      nome: resposta.model.business_name,
      fantasia: resposta.model.fantasy_name,
      cnpj: resposta.model.cnpj,
    });

    return {
      fornecedor,
    };
  },

  receberUnidade: async ({ commit }) => {
    let unidade = localStorage.getItem("unidade");
    if (unidade != null && unidade != undefined && unidade != "") {
      commit("SAVE_UNIDADE", JSON.parse(unidade));
      return;
    }
    commit("SAVE_UNIDADE", { nome: "", logo: "", id: "" });
  },

  saveUnidade({ commit }, data) {
    commit("SAVE_UNIDADE", data);
  },
  saveTodasUnidade({ commit }, data) {
    commit("ALL_UNIDADES", data);
  },
};

export const org = {
  namespaced: true,
  actions,
  state,
  mutations,
};
